import { Deserializable } from '@common/interfaces/deserializable';
import { Clinic } from './clinic';
import { Doctor } from './doctor';
import { Question } from './question';

interface TypeTimeFrameOption {
  value: number;
  name: string;
}
export interface MenuInput {
  id: number;
  name: string;
  questions: Question[];
  description: string;
  explanation: string;
  fee: string;
  is_free: boolean;
  is_default: boolean;
  main_symptom: string;
  status: number;
  time_frame: number;
  type: number;
  clinics?: Clinic[];
  time_frame_option?: TypeTimeFrameOption;
  target_gender: number;
  doctors?: Doctor[];
  desc_html?: string;
  overview?: string;
}

export class Menu implements Deserializable<Menu>, MenuInput {
  id!: number;
  name: string = '';
  questions: Question[] = [];
  description: string = '';
  explanation: string = '';
  fee: string = '';
  is_free: boolean = true;
  is_default: boolean = false;
  main_symptom: string = '';
  status: number = 1;
  time_frame: number;
  type: number;
  clinics: Clinic[] = [];
  time_frame_option: TypeTimeFrameOption = {
    name: '30分',
    value: 30,
  };
  target_gender: number = 2;
  doctors: Doctor[] = [];
  image: any = null;
  image_url: string;
  desc_html: string = '';
  overview: string = '';

  get clinicNames() {
    return this.clinics.map((item: Clinic) => item.name).join('、');
  }

  deserialize(input: Partial<MenuInput>): Menu {
    Object.assign(this, input);

    if (input.questions && input.questions.length) {
      this.questions = input.questions.map((item: Question) =>
        new Question().deserialize(item),
      );
    }

    if (input.clinics && input.clinics.length) {
      this.clinics = input.clinics.map((item: Clinic) =>
        new Clinic().deserialize(item),
      );
    }

    if (input.doctors && input.doctors.length) {
      this.doctors = input.doctors.map((item: Doctor) =>
        new Doctor().deserialize(item),
      );
    }

    if (input.fee && +input.fee === 0) {
      this.fee = '';
    }

    if (input.desc_html) {
      this.desc_html = input.desc_html;
    }

    return this;
  }

  timeFrameOption() {
    this.time_frame_option = {
      name: this.time_frame + '分',
      value: this.time_frame,
    };
  }

  formJSONData(method: string) {
    const data = {
      name: this.name,
      status: this.status,
      is_free: this.is_free ? 1 : 0,
      fee: this.fee || 0,
      description: this.description,
      type: 0,
      time_frame: this.time_frame_option.value,
      clinic_ids: this.clinics.length > 0 ? this.clinics.map((item: Clinic) => item.id) : null,
      target_gender: this.target_gender,
      doctor_ids: this.doctors.map((item: Doctor) => item.id),
      is_default: this.is_default ? 1 : 0,
      main_symptom: this.main_symptom,
      explanation: this.explanation,
      image: this.image ? this.image : null,
      desc_html: this.desc_html || null,
      _method: method,
      overview: this.overview,
    };
    return data;
  }
}
